var map = {
	"./fonts/Poppins/Poppins-Black.ttf": 2120,
	"./fonts/Poppins/Poppins-Bold.ttf": 8192,
	"./fonts/Poppins/Poppins-Light.ttf": 6129,
	"./fonts/Poppins/Poppins-Medium.ttf": 8301,
	"./fonts/Poppins/Poppins-Regular.ttf": 9434,
	"./fonts/SanFrancisco/SFProDisplay-Black.ttf": 3389,
	"./fonts/SanFrancisco/SFProDisplay-Bold.ttf": 4511,
	"./fonts/SanFrancisco/SFProDisplay-Medium.ttf": 8594,
	"./fonts/SanFrancisco/SFProDisplay-Regular.ttf": 3611,
	"./fonts/SanFrancisco/SFProDisplay-Thin.ttf": 6663,
	"./images": 2710,
	"./images/": 2710,
	"./images/content": 4838,
	"./images/content/": 4838,
	"./images/content/404.svg": 5221,
	"./images/content/devices.png": 594,
	"./images/content/download.svg": 324,
	"./images/content/hiw-1.png": 5558,
	"./images/content/hiw-1@2x.png": 5448,
	"./images/content/hiw-2.png": 7530,
	"./images/content/hiw-2@2x.png": 3636,
	"./images/content/hiw-3.png": 2905,
	"./images/content/hiw-3@2x.png": 1793,
	"./images/content/hiw-4.png": 8419,
	"./images/content/hiw-d-1.png": 3726,
	"./images/content/hiw-d-2.png": 1140,
	"./images/content/hiw-d-3.png": 7774,
	"./images/content/index": 4838,
	"./images/content/index.js": 4838,
	"./images/content/integ.png": 6941,
	"./images/content/integ@2x.png": 7258,
	"./images/content/iphone.png": 9553,
	"./images/content/lightning.svg": 3917,
	"./images/content/logos/android-dark.svg": 8949,
	"./images/content/logos/android.svg": 8001,
	"./images/content/logos/apple-dark.svg": 8838,
	"./images/content/logos/apple.svg": 2854,
	"./images/content/logos/bcvault.svg": 7293,
	"./images/content/logos/coinpayments.svg": 4637,
	"./images/content/logos/dextools.svg": 9961,
	"./images/content/logos/download.svg": 5648,
	"./images/content/logos/electrical-plug.svg": 9220,
	"./images/content/logos/facebook.svg": 2555,
	"./images/content/logos/ferrari.svg": 2680,
	"./images/content/logos/flag.svg": 4122,
	"./images/content/logos/goldlines.svg": 8309,
	"./images/content/logos/google-dark.svg": 2409,
	"./images/content/logos/rotashow.svg": 5512,
	"./images/content/logos/spacechain.svg": 4112,
	"./images/content/logos/travala.svg": 819,
	"./images/content/logos/travelers.svg": 8075,
	"./images/content/logos/user-green.svg": 2230,
	"./images/content/logos/user.svg": 2034,
	"./images/content/logos/velhalla.svg": 3166,
	"./images/content/logos/velocity9.svg": 8219,
	"./images/content/logos/wagyu.svg": 4235,
	"./images/content/logos/waves.svg": 4416,
	"./images/content/medal-1.svg": 7526,
	"./images/content/medal.svg": 8738,
	"./images/content/mobile-app.svg": 3387,
	"./images/content/mobile-app@2x.png": 5947,
	"./images/content/mouse.svg": 8974,
	"./images/content/qr.png": 7814,
	"./images/content/stopwatch.svg": 650,
	"./images/content/va-form.png": 6622,
	"./images/content/va-main.png": 3556,
	"./images/content/va-main@2x.png": 4264,
	"./images/content/web-app.svg": 2358,
	"./images/content/web-app@2x.png": 3068,
	"./images/content/whistle.svg": 460,
	"./images/content/windows.svg": 9108,
	"./images/error-icon.svg": 6440,
	"./images/index": 2710,
	"./images/index.js": 2710,
	"./images/logo-dark.svg": 330,
	"./images/logo-light.svg": 1066,
	"./images/relying-party/Spinner_VA.gif": 1010,
	"./images/relying-party/error-icon.svg": 213,
	"./images/relying-party/integ.svg": 7245,
	"./images/relying-party/intro-1.png": 2233,
	"./images/relying-party/success-icon.svg": 223,
	"./images/success-icon.svg": 2552,
	"./text/en": 5360,
	"./text/en.json": 5360,
	"./text/ru": 3993,
	"./text/ru.json": 3993,
	"./text/uk": 1524,
	"./text/uk.json": 1524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;